import React, { useCallback } from 'react';

import clamp from '../utils/clamp';
import { cx } from '../utils/cx';

function NumberSelector({
    value,
    suffix,
    min,
    max,
    disabled,
    onChange,
    onClickDisabled,
}) {
    const onClick = useCallback(
        (e, change) => {
            e.preventDefault();

            if (disabled && onClickDisabled != null) {
                return onClickDisabled();
            }

            onChange(
                clamp(
                    value + change,
                    min != null ? min : 0,
                    max != null ? max : Number.MAX_VALUE,
                ),
                value,
            );
        },
        [value, min, max, onChange, onClickDisabled],
    );

    let disabledNegative = value === (min != null ? min : 0);
    let disabledPositive = value === (max != null ? max : Number.MAX_VALUE);

    if (disabled) {
        disabledNegative = true;
        disabledPositive = true;
    }

    return (
        <div
            className="number-selector p-1 rounded-full border border-black/10 inline-flex items-center gap-4 sm:min-w-48"
            translate="no"
        >
            <button
                onClick={(e) => onClick(e, -1)}
                disabled={disabledNegative}
                className={cx(
                    'flex items-center justify-center h-10 w-10 basis-10 rounded-full text-primarytext',
                    !disabledNegative && 'bg-primary',
                    disabledNegative && 'bg-disabled',
                )}
            >
                <i className="icon-minus text-[20px]"></i>
            </button>
            <div className="number-selector__value text-sm text-center flex-1">
                {value}
            </div>
            {disabledPositive && onClickDisabled != null ? (
                <button
                    onClick={onClickDisabled}
                    className={cx(
                        'flex items-center justify-center h-10 w-10 basis-10 rounded-full text-primarytext',
                        !disabledPositive && 'bg-primary',
                        disabledPositive && 'bg-disabled',
                    )}
                >
                    <i className="icon-plus text-[20px]"></i>
                </button>
            ) : (
                <button
                    onClick={(e) => onClick(e, +1)}
                    disabled={disabledPositive}
                    className={cx(
                        'flex items-center justify-center h-10 w-10 basis-10 rounded-full text-primarytext',
                        !disabledPositive && 'bg-primary',
                        disabledPositive && 'bg-disabled',
                    )}
                >
                    <i className="icon-plus text-[20px]"></i>
                </button>
            )}
        </div>
    );
}

export { NumberSelector };
